// extracted by mini-css-extract-plugin
module.exports = {"defaultPageStyle":"style_defaultPageStyle__aupXF"};